export default class ApiExtension {
  constructor(apiBase) {
    this.apiBase = apiBase
    this.routes = apiBase.routes
  }

  fetch() {
    return this.apiBase.fetch.apply(this.apiBase, arguments)
  }

  createUrl() {
    return this.apiBase.createUrl.apply(this.apiBase, arguments)
  }
}
